import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

export const DeleteImagesModal = ({
  isOpen,
  onClose,
  allImages,
  selectedImages,
  onToggleSelection,
  onSelectAll,
  onDeleteSelected,
  isVariants = false
}) => {
  if (!isOpen) return null;

  const bPlusImages = !isVariants ? allImages.filter(img => img && img.sequenceType === 'bPlus') : [];
  const aPlusImages = !isVariants ? allImages.filter(img => img && img.sequenceType === 'aPlus') : [];

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={onClose}>
      <div className={styles.removeBgModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.removeBgModalHeader}>
          <div className={styles.removeBgModalTitleContainer}>
            <svg width="34" height="38" viewBox="0 0 34 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32.546 7.7955H27.8552L26.9244 4.05943C26.3287 1.66798 24.1956 0 21.7402 0H12.2645C9.80896 0 7.6777 1.66798 7.08029 4.05943L6.14946 7.7955H1.45727C0.652112 7.7955 0 8.44952 0 9.25703C0 10.0646 0.652112 10.7186 1.45727 10.7186H2.04382L3.6304 33.0233C3.82896 35.813 6.1697 38 8.96052 38H25.0395C27.8302 38 30.1709 35.8132 30.3696 33.0233L31.9562 10.7186H32.5427C33.3479 10.7186 34 10.0646 34 9.25703C34 8.44952 33.3479 7.7955 32.5427 7.7955H32.546ZM9.90908 4.76826C10.1805 3.68125 11.1496 2.92308 12.2662 2.92308H21.742C22.8586 2.92308 23.8277 3.68308 24.0991 4.76826L24.8533 7.7955H9.15298L9.90712 4.76826H9.90908ZM27.4654 32.8153C27.3761 34.0832 26.3105 35.077 25.0427 35.077H8.96183C7.69216 35.077 6.62837 34.0832 6.53912 32.8153L4.96526 10.7187H29.0375L27.4637 32.8153H27.4654ZM19.4305 26.7956V17.0527C19.4305 16.2452 20.0827 15.5911 20.8878 15.5911C21.693 15.5911 22.3451 16.2452 22.3451 17.0527V26.7956C22.3451 27.6032 21.693 28.2572 20.8878 28.2572C20.0827 28.2572 19.4305 27.6032 19.4305 26.7956ZM11.6597 26.7956V17.0527C11.6597 16.2452 12.3118 15.5911 13.1169 15.5911C13.9221 15.5911 14.5742 16.2452 14.5742 17.0527V26.7956C14.5742 27.6032 13.9221 28.2572 13.1169 28.2572C12.3118 28.2572 11.6597 27.6032 11.6597 26.7956Z" fill="#505050"/>
            </svg>
            <h2 className={styles.removeBgModalTitle}>Delete Images</h2>
          </div>
          <button type="button" className={styles.removeBgModalClose} onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
            </svg>
          </button>
        </div>

        <div className={styles.removeBgModalDivider}></div>

        <div className={styles.removeBgModalContent}>
          <div className={styles.removeBgModalSelectionInfo}>
            <div className={styles.removeBgModalSelectionText}>
              <span>Select Images to Delete</span>
              <span className={styles.removeBgModalCount}>({selectedImages.size}/{allImages.length} Selected)</span>
            </div>
            <label className={styles.removeBgModalSelectAll}>
              <input type="checkbox" checked={selectedImages.size === allImages.length && allImages.length > 0} onChange={onSelectAll} />
              <span>Select All</span>
            </label>
          </div>

          <div className={styles.removeBgModalGrid}>
            {!isVariants && bPlusImages.length > 0 && (
              <>
                <div className={styles.removeBgModalSectionHeading}>B+ images</div>
                {bPlusImages.filter(imageData => imageData && imageData.image && imageData.uniqueId).map((imageData) => {
                  const { image, uniqueId } = imageData;
                  const isSelected = selectedImages.has(uniqueId);
                  return (
                    <div key={uniqueId} className={`${styles.removeBgModalImageCard} ${isSelected ? styles.removeBgModalImageCardSelected : ''}`} onClick={() => onToggleSelection(uniqueId)}>
                      <img src={image?.previewUrl || ''} alt="Product image" />
                      <div className={styles.removeBgModalCheckbox}>
                        {isSelected ? (
                          <div className={styles.removeBgModalCheckboxChecked}>
                            <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        ) : (
                          <div className={styles.removeBgModalCheckboxUnchecked}></div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            {!isVariants && aPlusImages.length > 0 && (
              <>
                <div className={styles.removeBgModalSectionHeading}>A+ images</div>
                {aPlusImages.filter(imageData => imageData && imageData.image && imageData.uniqueId).map((imageData) => {
                  const { image, uniqueId } = imageData;
                  const isSelected = selectedImages.has(uniqueId);
                  return (
                    <div key={uniqueId} className={`${styles.removeBgModalImageCard} ${isSelected ? styles.removeBgModalImageCardSelected : ''}`} onClick={() => onToggleSelection(uniqueId)}>
                      <img src={image?.previewUrl || ''} alt="Product image" />
                      <div className={styles.removeBgModalCheckbox}>
                        {isSelected ? (
                          <div className={styles.removeBgModalCheckboxChecked}>
                            <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        ) : (
                          <div className={styles.removeBgModalCheckboxUnchecked}></div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            {isVariants && allImages.filter(imageData => imageData && imageData.image && imageData.uniqueId).map((imageData) => {
              const { image, uniqueId } = imageData;
              const isSelected = selectedImages.has(uniqueId);
              return (
                <div key={uniqueId} className={`${styles.removeBgModalImageCard} ${isSelected ? styles.removeBgModalImageCardSelected : ''}`} onClick={() => onToggleSelection(uniqueId)}>
                  <img src={image?.previewUrl || ''} alt="Product image" />
                  <div className={styles.removeBgModalCheckbox}>
                    {isSelected ? (
                      <div className={styles.removeBgModalCheckboxChecked}>
                        <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    ) : (
                      <div className={styles.removeBgModalCheckboxUnchecked}></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <button type="button" className={styles.removeBgModalActionButton} onClick={onDeleteSelected} disabled={selectedImages.size === 0}>
            Delete Selected
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
